module.exports = __webpack_public_path__ + "static/img/fontawesome-webfont.776d58f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/fontawesome-webfont.svg?v=4.1.0
// module id = Njt+
// module chunks = 1